const eftStyle = {
	
};

export default eftStyle;
